import { useEffect } from 'react'
import FooterBg from '../../../assets/images/footer/footerbg.webp'
import TcsFooter from '../../../assets/images/footer/tcsfooter.webp'
import SocialMedia from '../../../assets/images/icons/socialmedia.svg'
import SocialMedia2 from '../../../assets/images/icons/socialmedia2.svg'
import Call from '../../../assets/images/icons/call.svg'
import Email from '../../../assets/images/icons/emaill.svg'
import Location from '../../../assets/images/icons/location.svg'
import { useNavigate } from 'react-router-dom'
import colors from '../../theme/color'
import { openDataRightsRequest } from '../../../app/utils/aithorisConsent'

const FooterWorkTogetherBlock = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const preload = (src: string) => {
      const img = new Image()
      img.src = src
      if ('decode' in img) {
        img.decode().catch(() => undefined)
      }
    }
    preload(FooterBg)
    preload(TcsFooter)
  }, [])

  const footerVars = {
    '--footer-link-hover': colors.white,
    '--footer-accent': colors.purple,
    '--footer-accent-glow': `${colors.purple}BF`,
  } as React.CSSProperties

  return (
    <div style={footerVars} className="relative text-center md:mx-5 xl:mx-40 px-6 py-8 md:rounded-xl overflow-hidden">

    {/* BACKGROUND IMAGE */}
    <div className="absolute inset-0 z-0">
      <img
        src={FooterBg}
        alt="background"
        loading="eager"
        decoding="async"
        className=" w-full h-full object-cover opacity-90"
      />
    </div>

    {/* CONTENT */}
    <div className="relative z-10">

      {/* TOP SECTION */}
      <button
        type="button"
        onClick={() => navigate('/contactus')}
        className="group max-w-[1600px] w-full text-center mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 px-4 sm:px-8 lg:px-16 py-4 sm:py-6 rounded-xl bg-black/20 transition-all duration-300 hover:bg-black/30"
      >

{/* TEXT */}
<h3 className="font-gilroy-semibold text-xl sm:text-2xl md:text-4xl lg:text-5xl leading-tight tracking-tight text-center sm:text-left">
  <span className="text-white">LET’S WORK </span>
  <span className="text-transparent [text-stroke:1px_white] [-webkit-text-stroke:1px_white]">
    TOGETHER
  </span>
</h3>

{/* BUTTON */}
<div
  className="w-[50px] h-[50px] sm:w-[60px] sm:h-[60px] lg:w-[70px] lg:h-[70px] rounded-full flex items-center justify-center shrink-0 transition-transform duration-300 group-hover:translate-x-1"
  style={{ backgroundColor: colors.purple }}
>
  <span className="relative block h-[24px] w-[24px] sm:h-[30px] sm:w-[30px] lg:h-[35px] lg:w-[35px]">
    <span className="absolute inset-0 flex items-center justify-center text-white font-semibold text-[24px] sm:text-[30px] lg:text-[35px] leading-none transition-all duration-300 group-hover:translate-x-2 group-hover:opacity-0">
      ↗
    </span>
    <span className="absolute inset-0 flex items-center justify-center text-white font-semibold text-[24px] sm:text-[30px] lg:text-[35px] leading-none opacity-0 -translate-x-2 transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-100">
      →
    </span>
  </span>
</div>

</button>

      {/* BOTTOM SECTION */}
      <div className="flex flex-col items-center justify-center gap-3 mt-7 md:mt-16">
<img
  src={TcsFooter}
  alt="logo"
  loading="eager"
  decoding="async"
  className="w-[360px] h-[70px] object-contain"
/>

<p className=" text-lg md:text-3xl font-gilroy font-sm text-gray-300 max-w-4xl">
  Empowering your digital transformation with innovative solutions.
</p>

<div className="flex flex-wrap justify-center font-rajdhani font-semibold gap-10 md:gap-20 text-gray-500 text-xl md:text-3xl lg:my-20 md:my-10 my-5">
  <span onClick={() => navigate('/')} className="cursor-pointer transition-all duration-300 hover:text-[var(--footer-link-hover)] hover:-translate-y-1"> Home</span>
  <span onClick={() => navigate('/aboutus')} className="cursor-pointer transition-all duration-300 hover:text-[var(--footer-link-hover)] hover:-translate-y-1"> About us</span>
  <span onClick={() => navigate('/service')} className="cursor-pointer transition-all duration-300 hover:text-[var(--footer-link-hover)] hover:-translate-y-1"> Service</span>
  <span onClick={() => navigate('/portfolio')} className="cursor-pointer transition-all duration-300 hover:text-[var(--footer-link-hover)] hover:-translate-y-1"> Portfolio</span>
  <span onClick={() => navigate('/gallery')} className="cursor-pointer transition-all duration-300 hover:text-[var(--footer-link-hover)] hover:-translate-y-1"> Gallery </span>
  <span onClick={() => navigate('/career')} className="cursor-pointer transition-all duration-300 hover:text-[var(--footer-link-hover)] hover:-translate-y-1"> Career</span>
</div>

<div className="flex justify-center mt-1 mb-3">
  <div className="flex gap-4">
    <a
      href="https://www.instagram.com/thecodingstudio/"
      target="_blank"
      rel="noreferrer"
      className="w-[60px] h-[60px] md:w-[78px] md:h-[78px] rounded-full border-2 flex items-center justify-center overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:scale-105"
      style={{ borderColor: colors.purple, boxShadow: `0 0 18px ${colors.purple}8C` }}
      aria-label="Instagram"
    >
      <img src={SocialMedia} alt="Instagram" className="w-[46%] h-[46%] object-contain" />
    </a>
    <a
      href="https://in.linkedin.com/company/thecodingstudio"
      target="_blank"
      rel="noreferrer"
      className="w-[60px] h-[60px] md:w-[78px] md:h-[78px] rounded-full border-2 flex items-center justify-center overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:scale-105"
      style={{ borderColor: colors.purple, boxShadow: `0 0 18px ${colors.purple}8C` }}
      aria-label="LinkedIn"
    >
      <img src={SocialMedia2} alt="LinkedIn" className="w-[46%] h-[46%] object-contain" />
    </a>
  </div>
</div>

<button
  type="button"
  onClick={openDataRightsRequest}
  className="font-gilroy text-sm md:text-base text-gray-400 underline underline-offset-4 transition-colors duration-300 hover:text-[var(--footer-link-hover)]"
>
  Privacy &amp; data rights request
</button>

<div className="grid grid-cols-1 lg:grid-cols-3 gap-8 md:gap-10 mt-4 items-start text-start font-gilroy text-white text-sm md:text-2xl">

  {/* Phone */}
  <div className="flex items-start gap-2 w-full">
    <a
      href="tel:+917990345580"
      className="flex items-start gap-2 group text-left"
    >
      <img
        src={Call}
        alt="phone"
        className="w-5 h-5 md:w-8 md:h-7 shrink-0 animate-pulse transition-all duration-300 group-hover:[filter:drop-shadow(0_0_12px_var(--footer-accent-glow))]"
      />
      <span className="group-hover:text-[var(--footer-accent)]">
        +91 7990345580
      </span>
    </a>
  </div>

  {/* Email */}
  <div className="flex items-start gap-2 w-full group">
    <img
      src={Email}
      alt="email"
      className="w-5 h-5 md:w-8 md:h-7 shrink-0 animate-pulse transition-all duration-300 group-hover:[filter:drop-shadow(0_0_12px_var(--footer-accent-glow))]"
    />

    <button
      type="button"
      className="text-left group-hover:text-[var(--footer-accent)]"
      onClick={() =>
        window.open(
          'https://mail.google.com/mail/?view=cm&fs=1&to=inquire@thecodingstudio.in'
        )
      }
    >
      inquire@thecodingstudio.in
    </button>
  </div>

  {/* Address */}
  <div className="flex items-start gap-2 w-full group">
    <img
      src={Location}
      alt="location"
      className="w-5 h-5 md:w-8 md:h-7 shrink-0 animate-pulse transition-all duration-300 group-hover:[filter:drop-shadow(0_0_12px_var(--footer-accent-glow))]"
    />

    <span>
      438, The Boulevard, Near Pratham Circle, Gallaria Street Green City Road,
      Pal, Adajan, Surat, Gujarat 395009
    </span>
  </div>

</div>


      </div>

    </div>

  </div>
  )
}

export default FooterWorkTogetherBlock;
